exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".owl-theme .owl-nav.disabled+.owl-dots {\n    margin-top: 4px !important;\n}\n\n.owl-dot span {\n    width: 30px !important;\n    height: 3px !important;\n    margin: 5px 3px !important;\n    \n}\n\n.active span {\n    background-color: #FF4E1A !important;\n}", ""]);

// exports
